export default __webpack_public_path__ + "static/media/bandage.dcadc7e2.svg";